import { BaseEntity } from '../../../../models';
import { Representante } from '../representante';

export class RepresentanteVinculado implements BaseEntity {
    readonly id: number;
    idRepresentante: number;
    representante: Representante;
    idRepresentanteVinculado: number;
    representanteVinculado: Representante;
}
